async function broadcastDates (dataset = '') {
  const esSearch = {
    'size': 0,
    'aggs': {
      'months': {
        'terms': {
          'field': 'broadcastdate',
          'format': 'yyyy-MM',
          'size': 50,
          'order': {'_key': 'asc'}
        },
        'aggs': {
          'start_date': {
            'max': {
              'field': 'broadcastmonthstartdate',
              'format': 'yyyy-MM-dd'
            }
          },
          'end_date': {
            'max': {
              'field': 'broadcastmonthenddate',
              'format': 'yyyy-MM-dd'
            }
          }
        }
      },
      'mri': {
        'filter': {
          'exists': {
            'field': 'mri.mri_yes'
          }
        },
        'aggs': {
          'latest_month': {
            'max': {
              'field': 'broadcastdate',
              'format': 'yyyy-MM'
            }
          }
        }
      },
      'ncs': {
        'filter': {
          'exists': {
            'field': 'ncs.ncs_yes'
          }
        },
        'aggs': {
          'latest_month': {
            'max': {
              'field': 'broadcastdate',
              'format': 'yyyy-MM'
            }
          }
        }
      }
    }
  }
  if (dataset && dataset !== 'amrld') esSearch.query = {'bool': {'must': {'exists': {'field': `${dataset}.${dataset}_yes`}}}}
  const url = `${process.env.ES_URL}/${process.env.LAS_INDEX}/_search?filter_path=aggregations`
  const auth = process.env.ES_AUTH
  const headers = { 'Content-Type': 'application/json' }
  if (auth) headers.Authorization = auth
  const results = await fetch(url, {method: 'POST', headers, body: JSON.stringify(esSearch)}).then(r => r.json())

  const months = results.aggregations.months.buckets
  results.aggregations.months.buckets = months.slice(-24)
  return {data: results}
}

export default broadcastDates



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/broadcastDates.js